/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketDisplayStatusModel } from '../../models/support-ticket-display-status-model';

export interface SaveDisplayStatus$Params {
      body?: SupportTicketDisplayStatusModel
}

export function SaveDisplayStatus(http: HttpClient, rootUrl: string, params?: SaveDisplayStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketDisplayStatusModel>> {
  const rb = new RequestBuilder(rootUrl, SaveDisplayStatus.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketDisplayStatusModel>;
    })
  );
}

SaveDisplayStatus.PATH = '/api/TicketStatusMappings/SaveDisplayStatus';
